export default __webpack_public_path__ + "static/media/patnerwithus.45be3028.gif";